import { Footer as AntdFooter } from "antd/es/layout/layout";
import './Footer.css'
import { Button, Col, Divider, Layout, Row } from "antd";
import FooterData from "../../data/SearchInvoice/footer";
import React from "react";
import {
    FullscreenExitOutlined, FullscreenOutlined
} from '@ant-design/icons';
const Footer: React.FC = () => {
    const [isHidden, setIsHidden] = React.useState(false);
    const toggle = () => { setIsHidden(!isHidden) }
    return (
        <Layout className="footer" >
            <Button className="footer-close-btn" icon={!isHidden ? <FullscreenExitOutlined /> : <FullscreenOutlined />} onClick={toggle}></Button>
            <AntdFooter className="footer" hidden={isHidden}>
                <Row gutter={16} style={{ height: "100%" }} >
                    {
                        FooterData.Agents.map((agent, index) => (
                            
                            <Col xs={24} md={8} className="agent-info" key={index} span={8}>
                                  <Divider className="agent-info-child"></Divider>
                                <h4 className="agent-info-child" >{agent.name}</h4>
                             
                                <p className="agent-info-child">{agent.copyRight}</p>
                                <p className="agent-info-child">Địa chỉ: {agent.address}</p>
                                <p className="agent-info-child">SĐT: {agent.phone}</p>
                                <a href={`mailto: ${agent.email}`} className="agent-info-child">Email: {agent.email}</a>
                              
                            </Col>
                        ))
                    }

                </Row>
                <Row className="copy-right">
                    <Divider orientation="center" className="footer-outsource">
                        {
                            FooterData.SocialLinks.map((socalLink, index) => (
                                <span key={index}>
                                    <Button className="footer-outsource-btn" icon={socalLink.icon} href={socalLink.href} target="_blank" > {socalLink.name}</Button>
                                    {index !== FooterData.SocialLinks.length - 1 ? <Divider type="vertical"></Divider> : <></>}
                                </span>
                            ))
                        }
                    </Divider>
                    <p>
                        Copyrights © {new Date().getFullYear()} Công ty TNHH Hóa đơn điện tử <strong><span>
                            M-Invoice
                        </span></strong>. All Rights Reserved.
                    </p>
                </Row>
            </AntdFooter >

        </Layout >)
}
export default Footer;